export default "__VITE_ASSET__WYF5Cztz__"